import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userAge: JSON.parse(localStorage.getItem('userAge')) || null,
  },
  getters: {
    getUserAge: state => state.userAge,
  },
  mutations: {
    setUserAge(state, payload) {
      state.userAge = payload;
      localStorage.setItem('userAge', JSON.stringify(payload));
    },
  },
  actions: {
    saveUserAge({ commit }, userAge) {
      commit('setUserAge', userAge);
    },
  },
  modules: {},
});